import { ContentType } from "./enums"

export function getContentType(entry) {
    const contentString = entry.identifier ? entry.identifier : entry.type
    switch (contentString) {
        case 'movie':
            return ContentType.Movie
        case 'kickerliveticker':
            return ContentType.KickerLiveTicker
        case 'audio':
            return ContentType.Podcast
        case 'article':
            return ContentType.Article
        case 'ressort':
            return ContentType.Ressort
        case 'gallery':
            return ContentType.Gallery
        case 'video':
            return ContentType.Video
        case 'glomexvideo':
            return ContentType.GlomexVideo
        case 'searchmodule':
            return ContentType.SearchModule
        case 'dailymotionvideo':
            return ContentType.DailyMotionVideo
        case 'image':
            return ContentType.Image
        case 'teasermodule':
            return ContentType.TeaserModule
        case 'infobox':
            return ContentType.InfoBox
        case 'infoboxteaser':
            return ContentType.InfoBoxTeaser  
        case 'linkbox':
            return ContentType.Linkbox
        case 'linkresource':
            return ContentType.LinkResource
        case 'freetext':
            return ContentType.FreeText
        case 'collectivebox':
            return ContentType.CollectiveBox
        case 'collectiveswipe':
            return ContentType.CollectiveSwipe
        case 'freehtml':
            return ContentType.FreeHtml
        case 'advert':
            return ContentType.Advert
        case 'qualifiobox':
            return ContentType.QualifioBox
        case 'liveticker':
            return ContentType.Liveticker
        case 'twentythreedegrees':
            return ContentType.TwentyThreeDegrees
        case 'kickermatchday':
            return ContentType.KickerMatchday
        case 'twentythreedegreesmodule':
            return ContentType.TwentyThreeDegreesModule
        case 'landingpage':
            return ContentType.Landingpage
        case 'unscaled':
            return ContentType.Unscaled
        case 'affiliatebox':
            return ContentType.AmazonAffiliateBox
        case 'masonrymodule':
            return ContentType.MasonryModule
        case 'storymodule':
            return ContentType.StoryModule
        case 'highlightmodule':
            return ContentType.HighlightModule
        case 'listmodule':
            return ContentType.ListModule
        case 'catchline':
            return ContentType.Catchline
        case 'amazonaffiliatebox':
            return ContentType.AmazonAffiliateBox
        case 'faq':
            return ContentType.Faq
        default:
            console.log("unknown *** ", contentString, entry)
            return ContentType.Unknown
    }
  }
